import TagTypeItemList, { TagTypeItemListProps } from './TagTypeItemList';

export type { TagTypeItemListProps };
export default TagTypeItemList;
